import { FiBriefcase, FiBookOpen, FiGlobe, FiShield, FiUsers } from 'react-icons/fi'
import type { ImpactArea } from '@/types/impact-areas'

export const areas: ImpactArea[] = [
  {
    title: 'Entrepreneurship Development',
    description:
      'We help aspiring entrepreneurs access mentorship, training, business support, and professional networks that grow their ability to launch and sustain ventures.',
    Icon: FiBriefcase,
  },
  {
    title: 'Education & Leadership',
    description:
      'Our programmes equip students and emerging leaders with practical knowledge, leadership skills, and the confidence to seize future opportunities.',
    Icon: FiBookOpen,
  },
  {
    title: 'Cultural Exchange',
    description:
      'Through festivals, collaborative initiatives, and cross-regional engagement, we promote cultural understanding between Africa and the Caribbean.',
    Icon: FiGlobe,
  },
  {
    title: 'Humanitarian Advocacy',
    description:
      'We support advocacy that protects vulnerable populations, raises awareness of critical issues, and promotes dignity, safety, and human rights.',
    Icon: FiShield,
  },
  {
    title: 'Institutional Partnerships',
    description:
      'We work with institutions, development organisations, government agencies, and businesses to widen reach and create broader, lasting impact.',
    Icon: FiUsers,
  },
]
